import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-6" }
const _hoisted_2 = { class: "flex gap-8 pb-2 px-2 h-32" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]

import { ref, computed, watch } from "vue";
import SidebarNavigation from "../../sidebar/sidebarNavigation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormIcons',
  props: {
    filter: { default: () => ({}) },
    activeValue: { default: "" }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getImageUrl = (value: string) => {
  if (!props.filter.image) return "";
  const processedVal = props.filter.lowercaseImage !== false ? value.toLowerCase() : value;
  return props.filter.image.replace("{value}", processedVal);
};

const updateValue = (val: string) => {
  emit("update", val);
};

const itemKeys = computed(() => Object.keys(props.filter.values || {}));
const itemRefs = ref<HTMLElement[]>([]);
const scrollContainer = ref<HTMLElement | null>(null);
const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = itemRefs.value[index];
  if (el && scrollContainer.value) {
    const container = scrollContainer.value;
    const elLeft = el.offsetLeft;
    const elWidth = el.clientWidth;
    const containerWidth = container.clientWidth;
    const targetScrollLeft = elLeft - (containerWidth / 2) + (elWidth / 2);
    container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }
};

watch(() => props.activeValue, (newVal) => {
  const idx = itemKeys.value.indexOf(newVal?.toString() || '');
  if (idx >= 0) manualIndex.value = idx;
}, { immediate: true });

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  itemRefs.value.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "overflow-x-auto no-scrollbar scroll-smooth",
      onScroll: onScroll
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.values, (label, val, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: val,
            ref_for: true,
            ref: el => { if (el && index !== undefined) itemRefs.value[index] = el as any },
            class: "flex flex-col justify-center items-center cursor-pointer min-w-fit",
            onClick: ($event: any) => (updateValue(val.toString()))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["w-16 h-16 overflow-hidden rounded-full flex items-center justify-center mb-2 transition-all duration-300", __props.activeValue === val ? 'shadow-md w-20 h-20 ring-1 ring-brand-main ring-opacity-50' : ''])
            }, [
              _createElementVNode("img", {
                src: getImageUrl(val.toString()),
                alt: label,
                class: "w-full h-full object-contain opacity-80",
                onError: _cache[0] || (_cache[0] = (e) => e.target.style.display = 'none')
              }, null, 40, _hoisted_4)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm text-gray-500 tracking-wide whitespace-nowrap", __props.activeValue === val ? 'font-bold' : ''])
            }, _toDisplayString(label), 3)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ], 544),
    _createVNode(SidebarNavigation, {
      total: itemKeys.value.length,
      modelValue: currentIndex.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentIndex).value = $event)),
      container: scrollContainer.value
    }, null, 8, ["total", "modelValue", "container"])
  ]))
}
}

})